<template>
  <AppModal :show="isOpen" @close="onClose()">
    <h3>{{ $t("discount.title") }}</h3>
    <p>{{ $t("discount.text") }}</p>
    <DiscountForm
      :saving="isSaving"
      :errors="validationErrors"
      :discounts="state.discounts"
      @submit="onSubmit($event)"
    />
  </AppModal>
</template>

<script setup lang="ts">
import AppModal from "@/components/app-modal.vue";
import { isOpen, close, cancel, state } from "./store";
import DiscountForm from "./discount-form.vue";
import { ref } from "vue";
import { api } from "@/api";
import { useI18n } from "vue-i18n";
import { getApiValidationErrors } from "../../utils/get-api-validation-errors";

const isSaving = ref(false);
const validationErrors = ref<any>(null);
const { t } = useI18n();

const onSubmit = async (code: string) => {
  isSaving.value = true;
  try {
    // need to submit all discounts
    // to be able to count correct price with delivery
    const codes = state.value.discounts.map((discount) => discount.code);
    const deliveryPrice = state.value.deliveryPrice ?? 0;
    const discounts = await api.discount.get(
      [...codes, code],
      state.value.productQuantities,
      deliveryPrice,
      state.value.saleId,
      code
    );

    if (!discounts || discounts.length === 0) {
      validationErrors.value = { code: t("discount.notFound") };
      return;
    }

    close(discounts);
    validationErrors.value = null;
  } catch (error: unknown) {
    const errors = getApiValidationErrors(error);
    if (errors) {
      // translating error messages manually here (in other places it's done in backend)
      validationErrors.value = Object.keys(errors).reduce((acc, key) => {
        acc[key] = t(String(errors[key]));
        return acc;
      }, {} as Record<string, string>);
    }
  } finally {
    isSaving.value = false;
  }
};

const onClose = () => {
  cancel();
  validationErrors.value = null;
};
</script>
